import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

import prosesshjelp from '@helsenorge/core-framework/prosesshjelp/store';
import Languages from '@helsenorge/core-utils/constants/languages';
import { additionalPageContentApi } from '@helsenorge/framework-utils/additional-page-content';
import { tjenesteTeksterApi } from '@helsenorge/framework-utils/cms-tjeneste-tekster';
import { createLanguageReducer } from '@helsenorge/framework-utils/language';

import { resourcesApi } from '../resources';
import { verktoyReducer } from './verktoy/slice/verktoySlice';

const rootReducer = combineReducers({
  language: createLanguageReducer([Languages.NORWEGIAN, Languages.NORWEGIAN_NYNORSK, Languages.ENGLISH]),
  prosesshjelp,
  [additionalPageContentApi.reducerPath]: additionalPageContentApi.reducer,
  [tjenesteTeksterApi.reducerPath]: tjenesteTeksterApi.reducer,
  [resourcesApi.reducerPath]: resourcesApi.reducer,
  verktoy: verktoyReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(additionalPageContentApi.middleware)
      .concat(tjenesteTeksterApi.middleware)
      .concat(resourcesApi.middleware),
});

export type VerktoyRootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useAppDispatch = () => useDispatch<AppDispatch>();

export function useAppSelector<TSelected = unknown>(selector: (state: VerktoyRootState) => TSelected): TSelected {
  return useSelector(selector);
}

export default rootReducer;
